<template>
  <div
    id="PdCloudSiL"
    :class="{
      en: $i18n.locale === 'en-US',
    }"
  >
    <div
      id="PdCloudSiLModuleOne"
      :style="{ 'background-image': 'url(' + imageUrl1 + ')' }"
      v-lazy="imageUrl1"
    >
      <div id="PdCloudSiLModuleOneText">
        <div id="PdCloudSiLModuleOneTextTextOne" class="module1 pre-wrap">
          <span>{{ $t("productCenterSiLView").title.h1 }}</span>
        </div>
        <div id="PdCloudSiLModuleOneTextTextThree" class="module1">
          {{ $t("productCenterSiLView").title.h2 }}
        </div>
      </div>
    </div>

    <div id="PdCloudSiLModuleTwo">
      <div id="PdCloudSiLModuleTwoNav" ref="PdCloudSiLModuleTwoNav">
        <div id="PdCloudSiLModuleTwoNavContent">
          <div
            id="PdCloudSiLModuleTwoNavProductionOne"
            ref="PdCloudSiLModuleTwoNavProductionOne"
          >
            <a
              @click.prevent="PdCloudSiLModuleTwoNavProductionOne($event)"
              href="#PdCloudSiLModuleTwoContent11"
            >
              {{ $t("productCenterSiLView").title.h3 }}
            </a>
          </div>

          <div
            id="PdCloudSiLModuleTwoNavProductionTwo"
            ref="PdCloudSiLModuleTwoNavProductionTwo"
          >
            <a
              @click.prevent="PdCloudSiLModuleTwoNavProductionTwo()"
              href="#PdCloudSiLModuleThree11"
            >
              {{ $t("productCenterSiLView").title.h4 }}</a
            >
          </div>

          <div
            id="PdCloudSiLModuleTwoNavProductionTherr"
            ref="PdCloudSiLModuleTwoNavProductionTherr"
          >
            <a
              @click.prevent="PdCloudSiLModuleTwoNavProductionTherr()"
              href="#PdCloudSiLModuleNine11"
            >
              {{ $t("productCenterSiLView").title.h5 }}</a
            >
          </div>
        </div>
      </div>

      <a
        id="section-0"
        name="PdCloudSiLModuleTwoContent11"
        ref="PdCloudSiLModuleTwoContent11"
      >
        <div id="PdCloudSiLModuleTwoContent">
          <div
            id="PdCloudSiLModuleTwoContentLeft"
            class="wow animate__animated animate__slideLeft"
          >
            <div id="PdCloudSiLModuleTwoContentLeftTop">
              {{ $t("productCenterSiLView").section.section0.h1 }}
            </div>
            <div id="PdCloudSiLModuleTwoContentLeftBottom">
              {{ $t("productCenterSiLView").section.section0.h2 }}
            </div>
          </div>
          <div
            id="PdCloudSiLModuleTwoContentRight"
            class="wow animate__animated animate__fromRight"
          >
            <div class="dievo">
              <video
                id="video"
                ref="videoTerritory"
                controlsList="nodownload"
                controls
                :src="$t('productCenterSiLView').section.section0.SiLVideo"
                muted
                autoplay
                loop
                x-webkit-airplay="allow"
                x5-video-player-type="h5"
                x5-video-player-fullscreen="true"
              ></video>
            </div>
          </div>
          <!-- <div id="PdCloudSiLModuleTwoContentRight" :style="{ 'background-image': 'url(' + imageUrl2 + ')' }"
            v-lazy="imageUrl2" class="wow animate__animated animate__fromRight"></div> -->
        </div>
      </a>
    </div>

    <a
      id="section-1"
      name="PdCloudSiLModuleThree11"
      ref="PdCloudSiLModuleThree11"
    >
      <div id="PdCloudSiLModuleThree">
        <div
          id="PdCloudSiLModuleFour"
          class="wow animate__animated animate__fadeInUp"
        >
          <div id="PdCloudSiLModuleFourComponent">
            {{ $t("productCenterSiLView").section.section1.h1 }}
          </div>
        </div>
        <div id="PdCloudSiLModuleFive">
          <div
            id="PdCloudSiLModuleFiveLeft"
            class="wow animate__animated animate__slideLeft"
          >
            <div id="PdCloudSiLModuleFiveLeftTitle">
              {{
                $t("productCenterSiLView").section.section1.section1Arr[0].h2
              }}
            </div>
            <div id="PdCloudSiLModuleFiveLeftText1">
              {{
                $t("productCenterSiLView").section.section1.section1Arr[0].h3
              }}
            </div>
            <div id="PdCloudSiLModuleFiveLeftText2">
              {{
                $t("productCenterSiLView").section.section1.section1Arr[0].h4
              }}
            </div>
          </div>
          <div
            id="PdCloudSiLModuleFiveright"
            :style="{ 'background-image': 'url(' + imageUrl3 + ')' }"
            v-lazy="imageUrl3"
            class="wow animate__animated animate__fromRight"
          ></div>
        </div>
        <div id="PdCloudSiLModuleSix">
          <div
            id="PdCloudSiLModuleSixLeft"
            :style="{ 'background-image': 'url(' + imageUrl4 + ')' }"
            v-lazy="imageUrl4"
            class="wow animate__animated animate__slideLeft"
          ></div>
          <div
            id="PdCloudSiLModuleSixRight"
            class="wow animate__animated animate__fromRight"
          >
            <div id="PdCloudSiLModuleSixRightTitle">
              {{
                $t("productCenterSiLView").section.section1.section1Arr[1].h2
              }}
            </div>
            <div id="PdCloudSiLModuleSixRightText1">
              {{
                $t("productCenterSiLView").section.section1.section1Arr[1].h3
              }}
            </div>
            <div id="PdCloudSiLModuleSixRightText2">
              {{
                $t("productCenterSiLView").section.section1.section1Arr[1].h4
              }}
            </div>
          </div>
        </div>
        <div id="PdCloudSiLModuleSeven">
          <div
            id="PdCloudSiLModuleSevenLeft"
            class="wow animate__animated animate__slideLeft"
          >
            <div id="PdCloudSiLModuleSevenLeftTitle">
              {{
                $t("productCenterSiLView").section.section1.section1Arr[2].h2
              }}
            </div>
            <div id="PdCloudSiLModuleSevenLeftText1">
              {{
                $t("productCenterSiLView").section.section1.section1Arr[2].h3
              }}
            </div>
            <div id="PdCloudSiLModuleSevenLeftText2">
              {{
                $t("productCenterSiLView").section.section1.section1Arr[2].h4
              }}
            </div>
          </div>
          <div
            id="PdCloudSiLModuleSevenRight"
            :style="{ 'background-image': 'url(' + imageUrl5 + ')' }"
            v-lazy="imageUrl5"
            class="wow animate__animated animate__fromRight"
          ></div>
        </div>
        <div id="PdCloudSiLModuleEight">
          <div
            id="PdCloudSiLModuleEightLeft"
            :style="{ 'background-image': 'url(' + imageUrl6 + ')' }"
            v-lazy="imageUrl6"
            class="wow animate__animated animate__slideLeft"
          ></div>
          <div
            id="PdCloudSiLModuleEightRight"
            class="wow animate__animated animate__fromRight"
          >
            <div id="PdCloudSiLModuleEightRightTitle">
              {{
                $t("productCenterSiLView").section.section1.section1Arr[3].h2
              }}
            </div>
            <template v-if="$i18n.locale === 'en-US'">
              <div id="PdCloudSiLModuleEightRightText1">
                {{
                  $t("productCenterSiLView").section.section1.section1Arr[3]
                    .h3 +
                  $t("productCenterSiLView").section.section1.section1Arr[3]
                    .h4 +
                  $t("productCenterSiLView").section.section1.section1Arr[3].h5
                }}
              </div>
            </template>
            <template v-else>
              <div id="PdCloudSiLModuleEightRightText1">
                {{
                  $t("productCenterSiLView").section.section1.section1Arr[3].h3
                }}
              </div>
              <div id="PdCloudSiLModuleEightRightText2">
                {{
                  $t("productCenterSiLView").section.section1.section1Arr[3].h4
                }}
              </div>
              <div id="PdCloudSiLModuleEightRightText3">
                {{
                  $t("productCenterSiLView").section.section1.section1Arr[3].h5
                }}
              </div>
            </template>
          </div>
        </div>
      </div>
    </a>

    <a
      id="section-2"
      name="PdCloudSiLModuleNine11"
      ref="PdCloudSiLModuleNine11"
    >
      <div
        id="PdCloudSiLModuleNine"
        :style="{ 'background-image': 'url(' + imageUrl7 + ')' }"
        v-lazy="imageUrl7"
      >
        <div
          id="PdCloudSiLModuleNineTitle"
          class="wow animate__animated animate__fadeInUp"
        >
          {{ $t("productCenterSiLView").section.section2.h1 }}
        </div>
        <div id="PdCloudSiLModuleNineContent">
          <div id="PdCloudSiLModuleNineContentCenter">
            <div
              id="PdCloudSiLModuleNineContentOne"
              class="wow animate__animated animate__fadeInUp"
              style="animation-duration: 1s !important"
            >
              <div id="PdCloudSiLModuleNineContentOneTop">
                <img src="@/static/img/pdCloundSiLIconOne.png" alt="" />
              </div>
              <div id="PdCloudSiLModuleNineContentOneCenter">
                {{
                  $t("productCenterSiLView").section.section2.section2Arr[0].h1
                }}
              </div>
              <div id="PdCloudSiLModuleNineContentOneBottom">
                {{
                  $t("productCenterSiLView").section.section2.section2Arr[0].h2
                }}
              </div>
            </div>
            <div
              id="PdCloudSiLModuleNineContentTwo"
              class="wow animate__animated animate__fadeInUp"
              style="animation-duration: 1.3s !important"
            >
              <div id="PdCloudSiLModuleNineContentTwoTop">
                <img src="@/static/img/pdCloundSiLIconTwo.png" alt="" />
              </div>
              <div id="PdCloudSiLModuleNineContentTwoCenter">
                {{
                  $t("productCenterSiLView").section.section2.section2Arr[1].h1
                }}
              </div>
              <div id="PdCloudSiLModuleNineContentTwoBottom">
                {{
                  $t("productCenterSiLView").section.section2.section2Arr[1].h2
                }}
              </div>
            </div>
            <div
              id="PdCloudSiLModuleNineContentThree"
              class="wow animate__animated animate__fadeInUp"
              style="animation-duration: 1.6s !important"
            >
              <div id="PdCloudSiLModuleNineContentThreeTop">
                <img src="@/static/img/pdCloundSiLIconThree.png" alt="" />
              </div>
              <div id="PdCloudSiLModuleNineContentThreeCenter">
                {{
                  $t("productCenterSiLView").section.section2.section2Arr[2].h1
                }}
              </div>
              <div id="PdCloudSiLModuleNineContentThreeBottom">
                {{
                  $t("productCenterSiLView").section.section2.section2Arr[2].h2
                }}
              </div>
            </div>
            <div
              id="PdCloudSiLModuleNineContentFour"
              class="wow animate__animated animate__fadeInUp"
              style="animation-duration: 1.9s !important"
            >
              <div id="PdCloudSiLModuleNineContentFourTop">
                <img src="@/static/img/pdCloundSiLIconFour.png" alt="" />
              </div>
              <div id="PdCloudSiLModuleNineContentFourCenter">
                {{
                  $t("productCenterSiLView").section.section2.section2Arr[3].h1
                }}
              </div>
              <div id="PdCloudSiLModuleNineContentFourBottom">
                {{
                  $t("productCenterSiLView").section.section2.section2Arr[3].h2
                }}
              </div>
            </div>
            <div
              id="PdCloudSiLModuleNineContentFive"
              class="wow animate__animated animate__fadeInUp"
              style="animation-duration: 2.2s !important"
            >
              <div id="PdCloudSiLModuleNineContentFiveTop">
                <img src="@/static/img/pdCloundSiLIconFive.png" alt="" />
              </div>
              <div id="PdCloudSiLModuleNineContentFiveCenter">
                {{
                  $t("productCenterSiLView").section.section2.section2Arr[4].h1
                }}
              </div>
              <div id="PdCloudSiLModuleNineContentFiveBottom">
                {{
                  $t("productCenterSiLView").section.section2.section2Arr[4].h2
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </a>
    <div id="footer">
      <FooterComponents></FooterComponents>
    </div>
  </div>
</template>

<script>
import FooterComponents from "@/components/FooterComponents.vue";
import { template } from "lodash";
import WOW from "wowjs";

export default {
  components: {
    FooterComponents,
  },
  data() {
    return {
      newWow: null,
      currentIndex: 0,
      productNameArr: ["产品介绍", "产品构成", "产品优势"],
      imageUrl1: require("@/static/img/pdCloudBanner.png"),
      // imageUrl2: require("@/static/img/pdCloundProduction.png"),
      imageUrl3: require("@/static/img/pdCloundSiLConstitute.png"),
      imageUrl4: require("@/static/img/pdCloundSiLLibrary.png"),
      imageUrl5: require("@/static/img/pdCloundSiLTest.png"),
      imageUrl6: require("@/static/img/pdCloundSiLRun.png"),
      imageUrl7: require("@/static/img/pdCloundSiLAdvantageBg.png"),
      scrollTop: 0,
    };
  },
  mounted() {
    this.$off("productCloundReload");
    this.$bus.$on("productCloundReload", () => {
      if (this.$refs.PdCloudSiLModuleTwoNav) {
        this.$refs.PdCloudSiLModuleTwoNav.style.position = "";
      }
    });
    this.newWow = new WOW.WOW({
      live: false,
    });
    this.newWow.init();
    window.addEventListener("scroll", this.scrolling);
  },

  destroyed() {
    // 移除滚动事件监听器
    window.removeEventListener("scroll", this.scrolling);
  },
  methods: {
    liClick(index) {
      this.currentIndex = index;
      const sectionId = "section-" + index;
      const targetElement = document.getElementById(sectionId);
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    },
    scrolling() {
      // 滚动条距文档顶部的距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      const anchorElement = document.querySelector("#PdCloudSiLModuleTwo");
      if (anchorElement) {
        var anchorTop = anchorElement.offsetTop - 48;
      }

      // 判断是否滚动到第一个锚点链接处
      if (scrollTop >= anchorTop) {
        this.$refs.PdCloudSiLModuleTwoNav.style.position = "fixed";
        this.$refs.PdCloudSiLModuleTwoNav.style.top = 3 + "rem";
        //现在有阴影
        this.$refs.PdCloudSiLModuleTwoNav.style.boxShadow =
          "0px .25rem .625rem 0px rgba(0, 0, 0, 0.40)";
      } else {
        this.$refs.PdCloudSiLModuleTwoNav.style.position = "";
        //现在没有阴影
        this.$refs.PdCloudSiLModuleTwoNav.style.boxShadow =
          "0px 0rem 0rem 0px rgba(0, 0, 0, 0.40)";
      }

      // 在这里根据滚动位置进行逻辑处理
      if (
        scrollTop >= document.getElementById("section-0").offsetTop &&
        scrollTop < document.getElementById("section-1").offsetTop
      ) {
        // 滚动到了Section 1
        this.$refs.PdCloudSiLModuleTwoNavProductionOne.style.color = "red";
        this.$refs.PdCloudSiLModuleTwoNavProductionOne.style.borderBottom =
          ".0625rem solid #D71F28";
        this.$refs.PdCloudSiLModuleTwoNavProductionTwo.style.color = "#50627B";
        this.$refs.PdCloudSiLModuleTwoNavProductionTwo.style.borderBottom =
          "0rem solid #D71F28";
        this.$refs.PdCloudSiLModuleTwoNavProductionTherr.style.color =
          "#50627B";
        this.$refs.PdCloudSiLModuleTwoNavProductionTherr.style.borderBottom =
          "0rem solid #D71F28";
      } else if (
        scrollTop >= document.getElementById("section-1").offsetTop - 48 &&
        scrollTop < document.getElementById("section-2").offsetTop
      ) {
        // 滚动到了Section 2
        this.$refs.PdCloudSiLModuleTwoNavProductionOne.style.color = "#50627B";
        this.$refs.PdCloudSiLModuleTwoNavProductionOne.style.borderBottom =
          "0rem solid #D71F28";
        this.$refs.PdCloudSiLModuleTwoNavProductionTwo.style.color = "red";
        this.$refs.PdCloudSiLModuleTwoNavProductionTwo.style.borderBottom =
          ".0625rem solid #D71F28";
        this.$refs.PdCloudSiLModuleTwoNavProductionTherr.style.color =
          "#50627B";
        this.$refs.PdCloudSiLModuleTwoNavProductionTherr.style.borderBottom =
          "0rem solid #D71F28";
      } else if (scrollTop >= document.getElementById("section-2").offsetTop) {
        // 滚动到了Section 3
        this.$refs.PdCloudSiLModuleTwoNavProductionOne.style.color = "#50627B";
        this.$refs.PdCloudSiLModuleTwoNavProductionOne.style.borderBottom =
          "0rem solid #D71F28";
        this.$refs.PdCloudSiLModuleTwoNavProductionTwo.style.color = "#50627B";
        this.$refs.PdCloudSiLModuleTwoNavProductionTwo.style.borderBottom =
          "0rem solid #D71F28";
        this.$refs.PdCloudSiLModuleTwoNavProductionTherr.style.color = "red";
        this.$refs.PdCloudSiLModuleTwoNavProductionTherr.style.borderBottom =
          ".0625rem solid #D71F28";
      }
    },

    PdCloudSiLModuleTwoNavProductionOne() {
      this.liClick(0);
      // 滚动到了Section 1
      // this.$refs.PdCloudSiLModuleTwoNavProductionOne.style.color = "red";
      // this.$refs.PdCloudSiLModuleTwoNavProductionOne.style.borderBottom =
      //   ".0625rem solid #D71F28";
      // this.$refs.PdCloudSiLModuleTwoNavProductionTwo.style.color = "#50627B";
      // this.$refs.PdCloudSiLModuleTwoNavProductionTwo.style.borderBottom =
      //   "0rem solid #D71F28";
      // this.$refs.PdCloudSiLModuleTwoNavProductionTherr.style.color = "#50627B";
      // this.$refs.PdCloudSiLModuleTwoNavProductionTherr.style.borderBottom =
      //   "0rem solid #D71F28";
    },

    PdCloudSiLModuleTwoNavProductionTwo() {
      this.liClick(1);
      // 滚动到了Section 2
      // this.$refs.PdCloudSiLModuleTwoNavProductionOne.style.color = "#50627B";
      // this.$refs.PdCloudSiLModuleTwoNavProductionOne.style.borderBottom =
      //   "0rem solid #D71F28";
      // this.$refs.PdCloudSiLModuleTwoNavProductionTwo.style.color = "red";
      // this.$refs.PdCloudSiLModuleTwoNavProductionTwo.style.borderBottom =
      //   ".0625rem solid #D71F28";
      // this.$refs.PdCloudSiLModuleTwoNavProductionTherr.style.color = "#50627B";
      // this.$refs.PdCloudSiLModuleTwoNavProductionTherr.style.borderBottom =
      //   "0rem solid #D71F28";
    },

    PdCloudSiLModuleTwoNavProductionTherr() {
      this.liClick(2);
      // 滚动到了Section 3
      if (
        this.$refs.PdCloudSiLModuleTwoNavProductionTherr.style.color != "red"
      ) {
        this.$refs.PdCloudSiLModuleTwoNavProductionOne.style.color = "#50627B";
        this.$refs.PdCloudSiLModuleTwoNavProductionOne.style.borderBottom =
          "0rem solid #D71F28";
        this.$refs.PdCloudSiLModuleTwoNavProductionTwo.style.color = "#50627B";
        this.$refs.PdCloudSiLModuleTwoNavProductionTwo.style.borderBottom =
          "0rem solid #D71F28";
        this.$refs.PdCloudSiLModuleTwoNavProductionTherr.style.color = "red";
        this.$refs.PdCloudSiLModuleTwoNavProductionTherr.style.borderBottom =
          ".0625rem solid #D71F28";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.animateFixd {
  position: fixed;
  top: 3rem;
}

//左下到右上
:global(.animate__slideLeft) {
  animation-name: zoomInLeft;
}

@keyframes zoomInLeft {
  from {
    opacity: 0;
    transform: translate(-50%, 50%) scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }

  to {
    opacity: 1;
    transform: none;
  }
}

/* 可选：调整动画持续时间 */
:global(.animate__slideLeft) {
  animation-duration: 1s !important;
}

//右下到左上
:global(.animate__fromRight) {
  animation-name: zoomInRight;
}

@keyframes zoomInRight {
  from {
    opacity: 0;
    transform: translate(50%, 50%) scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }

  to {
    opacity: 1;
    transform: none;
  }
}

/* 可选：调整动画持续时间 */
:global(.animate__fromRight) {
  animation-duration: 1s !important;
}

@mixin whar($width, $height, $atio) {
  width: $width;
  height: $height;
  aspect-ratio: $atio;
  box-sizing: border-box;
}

@mixin display {
  display: flex;
  align-items: center;
  justify-content: center;
}

@mixin commitaspct {
  opacity: 1;
  width: 50%;
  aspect-ratio: 720/600;
  background-size: contain;
}

@mixin fontStyle(
  $fontweight,
  $height,
  $fontSize,
  $lineHeight,
  $letterSpaceing,
  $color
) {
  width: fit-content;
  font-weight: $fontweight;
  height: $height;
  font-size: $fontSize;
  font-style: normal;
  line-height: $lineHeight;
  letter-spacing: $letterSpaceing;
  color: $color;
}

@mixin shotFontStyle($color, $fontSize, $fontweight, $lineHeight) {
  color: $color;
  font-size: $fontSize;
  font-style: normal;
  font-weight: $fontweight;
  line-height: $lineHeight;
}

#PdCloudSiL {
  width: 100%;
  // height: 100%;
  box-sizing: border-box;
}

#PdCloudSiLModuleOne {
  background-size: cover;
  @include whar(100%, auto, 1440/480);
  padding: 12.9375rem 12.9375rem 0rem 12.8125rem;

  #PdCloudSiLModuleOneText {
    height: 7.75rem;
    width: fit-content;
    line-height: 3.875rem;

    #PdCloudSiLModuleOneTextTextOne {
      @include fontStyle(
        600,
        // 3.875rem,
        auto,
        2.5rem,
        3.875rem,
        0.06944rem,
        rgba(255, 255, 255, 0.85)
      );
    }

    #PdCloudSiLModuleOneTextTextThree {
      opacity: 1;
      margin-top: 0.75rem;
      @include fontStyle(
        400,
        2rem,
        1.0625rem,
        2rem,
        0.06944rem,
        rgba(255, 255, 255, 0.65)
      );
    }
  }
}

#PdCloudSiLModuleTwo {
  display: flex;
  flex-direction: column;
  background-size: cover;
  @include whar(100%, auto, 1440/550);

  #PdCloudSiLModuleTwoNav {
    width: 100%;
    display: flex;
    height: 3rem;
    background: #0c132b;
    justify-content: center;
    border-bottom: 0.0625rem solid rgba(47, 83, 125, 0.3);
    z-index: 6;

    #PdCloudSiLModuleTwoNavContent {
      display: flex;
      justify-content: space-between;
      @include fontStyle(500, 3rem, 1rem, 3rem, 0rem, #50627b);
      width: 35rem;

      #PdCloudSiLModuleTwoNavProductionOne a,
      #PdCloudSiLModuleTwoNavProductionTwo a,
      #PdCloudSiLModuleTwoNavProductionTherr a {
        text-decoration: none;
        /* 去除下划线 */
        color: inherit;
        /* 继承父元素的字体颜色 */
      }

      #PdCloudSiLModuleTwoNavProductionOne {
        color: #d71f28;
        border-bottom: 0.0625rem solid #d71f28;
      }

      #PdCloudSiLModuleTwoNavProductionOne:hover,
      #PdCloudSiLModuleTwoNavProductionTwo:hover,
      #PdCloudSiLModuleTwoNavProductionTherr:hover {
        cursor: pointer;
        color: #d71f28;
        border-bottom: 0.0625rem solid #d71f28;
      }

      .productUl {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        // border: 1px solid red;

        .active {
          color: #d71f28;
          border-bottom-color: #d71f28;
        }

        li {
          border-bottom: 1px solid transparent;
        }

        li:hover {
          cursor: pointer;
          color: #d71f28;
          border-bottom-color: #d71f28;
        }
      }
    }
  }

  #PdCloudSiLModuleTwoContent {
    flex: 1;
    display: flex;
    box-sizing: border-box;

    #PdCloudSiLModuleTwoContentLeft {
      // height: 7rem;
      // display: flex;
      width: 23.875rem;
      margin-top: 12.75rem;
      margin-left: 10.5rem;
      // flex-direction: column;
      // justify-content: space-between;

      #PdCloudSiLModuleTwoContentLeftTop {
        @include shotFontStyle(rgba(255, 255, 255, 0.85), 1.5rem, 600, 2.5rem);
        width: 22rem;
      }

      #PdCloudSiLModuleTwoContentLeftBottom {
        margin-top: 1.25rem;
        @include shotFontStyle(
          rgba(255, 255, 255, 0.65),
          0.875rem,
          400,
          1.625rem
        );
      }
    }

    #PdCloudSiLModuleTwoContentRight {
      @include whar(100%, auto, 940/501);
      background-size: cover;

      .dievo {
        margin: 0 auto;
        transform: translateY(20%);
        width: 50.875rem;
        // height: 26rem;
        object-fit: cover;

        video {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
}

#PdCloudSiLModuleThree {
  #PdCloudSiLModuleFour {
    width: 100%;
    display: flex;
    height: 10.5rem;
    padding-top: 4.88rem;
    justify-content: center;
    box-sizing: border-box;

    #PdCloudSiLModuleFourComponent {
      width: 59.625rem;
      height: 3.125rem;
      color: rgba(255, 255, 255, 0.85);
      text-align: center;
      font-size: 2.25rem;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }

  #PdCloudSiLModuleFive {
    height: 30.3125rem;
    display: flex;

    #PdCloudSiLModuleFiveLeft {
      flex: 1 1 auto;
      box-sizing: border-box;
      padding-left: 10.5rem;
      padding-top: 11.66rem;

      #PdCloudSiLModuleFiveLeftTitle {
        @include shotFontStyle(rgba(255, 255, 255, 0.85), 1.5rem, 600, 2.5rem);
      }

      #PdCloudSiLModuleFiveLeftText1 {
        margin-top: 1.25rem;
        @include shotFontStyle(
          rgba(255, 255, 255, 0.65),
          0.875rem,
          400,
          1.625rem
        );
      }

      #PdCloudSiLModuleFiveLeftText2 {
        @include shotFontStyle(
          rgba(255, 255, 255, 0.65),
          0.875rem,
          400,
          1.625rem
        );
      }
    }

    #PdCloudSiLModuleFiveright {
      width: 50.875rem;
      background-size: cover;
    }
  }

  #PdCloudSiLModuleSix {
    display: flex;
    height: 30.3125rem;

    #PdCloudSiLModuleSixLeft {
      width: 50.875rem;
      background-size: cover;
    }

    #PdCloudSiLModuleSixRight {
      flex: 1 1 auto;
      box-sizing: border-box;
      padding-left: 4.69rem;
      padding-top: 11.66rem;

      #PdCloudSiLModuleSixRightTitle {
        @include shotFontStyle(rgba(255, 255, 255, 0.85), 1.5rem, 600, 2.5rem);
      }

      #PdCloudSiLModuleSixRightText1 {
        margin-top: 1.25rem;
        @include shotFontStyle(
          rgba(255, 255, 255, 0.65),
          0.875rem,
          400,
          1.625rem
        );
      }

      #PdCloudSiLModuleSixRightText2 {
        @include shotFontStyle(
          rgba(255, 255, 255, 0.65),
          0.875rem,
          400,
          1.625rem
        );
      }
    }
  }

  #PdCloudSiLModuleSeven {
    display: flex;
    height: 30.3125rem;

    #PdCloudSiLModuleSevenLeft {
      flex: 1 1 auto;
      box-sizing: border-box;
      padding-left: 10.5rem;
      padding-top: 11.66rem;

      #PdCloudSiLModuleSevenLeftTitle {
        @include shotFontStyle(rgba(255, 255, 255, 0.85), 1.5rem, 600, 2.5rem);
      }

      #PdCloudSiLModuleSevenLeftText1 {
        margin-top: 1.25rem;
        @include shotFontStyle(
          rgba(255, 255, 255, 0.65),
          0.875rem,
          400,
          1.625rem
        );
      }

      #PdCloudSiLModuleSevenLeftText2 {
        @include shotFontStyle(
          rgba(255, 255, 255, 0.65),
          0.875rem,
          400,
          1.625rem
        );
      }
    }

    #PdCloudSiLModuleSevenRight {
      width: 50.875rem;
      background-size: cover;
    }
  }

  #PdCloudSiLModuleEight {
    display: flex;
    height: 30.3125rem;

    #PdCloudSiLModuleEightLeft {
      width: 50.875rem;
      background-size: cover;
    }

    #PdCloudSiLModuleEightRight {
      flex: 1 1 auto;
      box-sizing: border-box;
      padding-left: 4.69rem;
      padding-top: 10.84rem;

      #PdCloudSiLModuleEightRightTitle {
        @include shotFontStyle(rgba(255, 255, 255, 0.85), 1.5rem, 600, 2.5rem);
      }

      #PdCloudSiLModuleEightRightText1 {
        margin-top: 1.25rem;
        @include shotFontStyle(
          rgba(255, 255, 255, 0.65),
          0.875rem,
          400,
          1.625rem
        );
      }

      #PdCloudSiLModuleEightRightText2 {
        @include shotFontStyle(
          rgba(255, 255, 255, 0.65),
          0.875rem,
          400,
          1.625rem
        );
      }

      #PdCloudSiLModuleEightRightText3 {
        @include shotFontStyle(
          rgba(255, 255, 255, 0.65),
          0.875rem,
          400,
          1.625rem
        );
      }
    }
  }
}

#PdCloudSiLModuleNine {
  display: flex;
  flex-direction: column;
  // background: rgb(15, 193, 238);
  background-size: cover;
  box-sizing: border-box;
  padding-top: 4.9375rem;
  @include whar(100%, auto, 1440/548);

  #PdCloudSiLModuleNineTitle {
    width: 48.75rem;
    height: 3.125rem;
    margin: 0 auto;
    color: rgba(255, 255, 255, 0.85);
    text-align: center;
    font-size: 2.25rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 1rem;
  }

  #PdCloudSiLModuleNineContent {
    height: 24rem;
    display: flex;
    justify-content: center;

    #PdCloudSiLModuleNineContentCenter {
      width: 84rem;
      display: flex;

      #PdCloudSiLModuleNineContentOne {
        width: 16.8rem;
        height: 24rem;
        box-sizing: border-box;
        padding: 4.06rem 2rem;

        #PdCloudSiLModuleNineContentOneTop {
          width: 4rem;
          height: 4rem;
          margin: 0 auto 1.06rem;

          img {
            width: 4rem;
            height: 4rem;
          }
        }

        #PdCloudSiLModuleNineContentOneCenter {
          text-align: center;
          @include shotFontStyle(
            rgba(255, 255, 255, 0.85),
            1.5rem,
            500,
            2.25rem
          );
        }

        #PdCloudSiLModuleNineContentOneBottom {
          margin-top: 1.25rem;
          text-align: center;
          @include shotFontStyle(
            rgba(255, 255, 255, 0.65),
            0.875rem,
            400,
            1.625rem
          );
        }
      }

      #PdCloudSiLModuleNineContentTwo {
        width: 16.8rem;
        height: 24rem;
        box-sizing: border-box;
        padding: 4.06rem 2rem;

        #PdCloudSiLModuleNineContentTwoTop {
          width: 4rem;
          height: 4rem;
          margin: 0 auto 1.06rem;

          img {
            width: 4rem;
            height: 4rem;
          }
        }

        #PdCloudSiLModuleNineContentTwoCenter {
          text-align: center;
          @include shotFontStyle(
            rgba(255, 255, 255, 0.85),
            1.5rem,
            500,
            2.25rem
          );
        }

        #PdCloudSiLModuleNineContentTwoBottom {
          margin-top: 1.25rem;
          text-align: center;
          @include shotFontStyle(
            rgba(255, 255, 255, 0.65),
            0.875rem,
            400,
            1.625rem
          );
        }
      }

      #PdCloudSiLModuleNineContentThree {
        width: 16.8rem;
        height: 24rem;
        box-sizing: border-box;
        padding: 4.06rem 2rem;

        #PdCloudSiLModuleNineContentThreeTop {
          width: 4rem;
          height: 4rem;
          margin: 0 auto 1.06rem;

          img {
            width: 4rem;
            height: 4rem;
          }
        }

        #PdCloudSiLModuleNineContentThreeCenter {
          text-align: center;
          @include shotFontStyle(
            rgba(255, 255, 255, 0.85),
            1.5rem,
            500,
            2.25rem
          );
        }

        #PdCloudSiLModuleNineContentThreeBottom {
          margin-top: 1.25rem;
          text-align: center;
          @include shotFontStyle(
            rgba(255, 255, 255, 0.65),
            0.875rem,
            400,
            1.625rem
          );
        }
      }

      #PdCloudSiLModuleNineContentFour {
        width: 16.8rem;
        height: 24rem;
        box-sizing: border-box;
        padding: 4.06rem 2rem;

        #PdCloudSiLModuleNineContentFourTop {
          width: 4rem;
          height: 4rem;
          margin: 0 auto 1.06rem;

          img {
            width: 4rem;
            height: 4rem;
          }
        }

        #PdCloudSiLModuleNineContentFourCenter {
          text-align: center;
          @include shotFontStyle(
            rgba(255, 255, 255, 0.85),
            1.5rem,
            500,
            2.25rem
          );
        }

        #PdCloudSiLModuleNineContentFourBottom {
          margin-top: 1.25rem;
          text-align: center;
          @include shotFontStyle(
            rgba(255, 255, 255, 0.65),
            0.875rem,
            400,
            1.625rem
          );
        }
      }

      #PdCloudSiLModuleNineContentFive {
        width: 16.8rem;
        height: 24rem;
        box-sizing: border-box;
        padding: 4.06rem 2rem;

        #PdCloudSiLModuleNineContentFiveTop {
          width: 4rem;
          height: 4rem;
          margin: 0 auto 1.06rem;

          img {
            width: 4rem;
            height: 4rem;
          }
        }

        #PdCloudSiLModuleNineContentFiveCenter {
          text-align: center;
          @include shotFontStyle(
            rgba(255, 255, 255, 0.85),
            1.5rem,
            500,
            2.25rem
          );
        }

        #PdCloudSiLModuleNineContentFiveBottom {
          margin-top: 1.25rem;
          text-align: center;
          @include shotFontStyle(
            rgba(255, 255, 255, 0.65),
            0.875rem,
            400,
            1.3rem
          );
          // line-height: 1.3rem;
        }
      }
    }
  }
}

#footer {
  width: 100%;
  height: 18rem;
}

.en {
  #PdCloudSiLModuleOneTextTextOne,
  #PdCloudSiLModuleTwoContentLeftTop,
  #PdCloudSiLModuleTwoContentLeftBottom {
    line-height: 1.5 !important;
  }
  // #PdCloudSiLModuleTwoContentLeftBottom {
  //   text-align: justify !important;
  // }
  #PdCloudSiLModuleEightRight {
    width: 42vw;
    padding-right: 3rem;
    // text-align: justify !important;
  }
  #PdCloudSiLModuleNineContent {
    height: auto !important;
  }
  #PdCloudSiLModuleNineContentOne,
  #PdCloudSiLModuleNineContentTwo,
  #PdCloudSiLModuleNineContentThree,
  #PdCloudSiLModuleNineContentFour,
  #PdCloudSiLModuleNineContentFive {
    height: auto !important;
    padding-left: 1.7rem !important;
    padding-right: 1.7rem !important;
  }
  #PdCloudSiLModuleNineContentOneCenter,
  #PdCloudSiLModuleNineContentTwoCenter,
  #PdCloudSiLModuleNineContentThreeCenter,
  #PdCloudSiLModuleNineContentFourCenter,
  #PdCloudSiLModuleNineContentFiveCenter {
    height: 3rem;
    font-size: 0.955rem !important;
    line-height: 1.5 !important;
    font-weight: bold !important;
  }
}
</style>
